import React from "react";

// Navigation
import { NavLink } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import "./navigation.scss";
//icons
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
let innerClassName;
function ListLink({
  icon,
  text,
  link,
  child,
  setListActiveItem,
  className,
  open,
}) {
  innerClassName = `${open ? "visible" : "invisible"} text-white`
  const customIsActive = (match, location) => {
    if (match) return true;
    let currentRoute = location.pathname.split("/");

    if (link === `/${currentRoute[1]}`) return true;
    return false;
  };

  return child ? (
    <ListItem
      className={`${className} sidebar_list_style   leading-8`}
      button
      component={NavLink}
      to={link}
      isActive={customIsActive}
      activeClassName="active-class" 
      onClick={(e) => {
        e.preventDefault();
        setListActiveItem(child);
      }}
    >
      {icon && <img src={icon} className="sidebar_list_icon" alt="ListItem" />}
      <ListItemText
        classes={{
          primary: ` ${
            open ? "visible" : "invisible"
          } pl-3   text-sm text-gray-400 lato`,
        }}
        primary={text}
      />
      <ChevronRightIcon
        className={innerClassName}
      />
    </ListItem>
  ) : (
    <ListItem
      className={`${className} sidebar_list_style  leading-1`}
      exact
      button
      component={NavLink}
      to={link}
      isActive={customIsActive}
      activeClassName="active-class"
    >
      {icon && <img src={icon} className="sidebar_list_icon" alt="ListItem" />}
      <ListItemText
        classes={{
          primary: `${
            open ? "visible" : "invisible"
          } pl-3  text-sm text-gray-400 lato`,
        }}
        primary={text}
      />
    </ListItem>
  );
}

export default ListLink;
